const AVATAR_COLORS = [
  "#E53935", "#D81B60", "#8E24AA", "#5E35B1",
  "#3949AB", "#1E88E5", "#039BE5", "#00ACC1",
  "#00897B", "#43A047", "#7CB342", "#F4511E",
  "#E65100", "#6D4C41", "#546E7A", "#757575",
];

export function useAvatarColor() {
  const getAvatarColor = (id: string): string => {
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = id.charCodeAt(i) + ((hash << 5) - hash);
    }
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
  };

  const getInitials = (firstName: string, lastName: string): string =>
    [firstName, lastName]
      .filter(Boolean)
      .map((p) => p[0])
      .join("")
      .toUpperCase();

  return { getAvatarColor, getInitials };
}
